export const BASE_URL = '/myplanner/api'